import NoticeGenerator from './NoticeGenerator';
import './NoticeGenerator.scss';

export default NoticeGenerator;
